export default __webpack_public_path__ + "static/media/P40001.7d4d699b.png";